import { faRoad } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { CustomIconType } from "ui/componentes/Icons";

const IconRoad: React.FC<CustomIconType> = (props) => {
    return <FontAwesomeIcon icon={faRoad} size="lg" {...props} />;
};

export { IconRoad };
